import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../core/constants/base-url";
import {resources} from "../../../../core/models/resource/resources";

@Injectable({
  providedIn: 'root'
})
export class TechnicalParametersApiService {
  private http: HttpClient = inject(HttpClient);

  public syncPassportArticles(productCardId: number): Observable<void> {
    const params = { productCardId: productCardId.toString() };
    return this.http.post<void>(`${baseUrl}/${resources['technical-parameters-product-card'].path}/articles/sync`, {}, {
      params
    });
  }
}
